import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, ValidationErrors, UntypedFormGroup } from '@angular/forms';

@Directive({
  selector: '[appMatchingFields]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: MatchingFieldsDirective,
      multi: true,
    },
  ],
})

export class MatchingFieldsDirective implements Validator {
  @Input('appMatchingFields') matchingFields: string[] = [];

  fieldsMatch(field1Name: string, field2Name: string) {
    return (formGroup: UntypedFormGroup) => {
      const field1 = formGroup.controls[field1Name];
      const field2 = formGroup.controls[field2Name];

      if (!field1 || !field2 || (field2.errors && !field2.errors.matchingFields)) { return null; }

      if (field1.value !== field2.value) {
        field2.setErrors({
          matchingFields: true,
        });
      } else {
        field2.setErrors(null);
      }
    };
  }

  validate(formGroup: UntypedFormGroup): ValidationErrors {
    return this.fieldsMatch(this.matchingFields[0], this.matchingFields[1])(formGroup);
  }
}
